import "./SnippetSidebarResource.css";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../redux/features/appData";
import { iconPath } from "winslow-core";
import {
  LinkRecord,
  getActivityLogoFilePathInMode,
  getAppLogoFromLinkRecord,
  Link,
} from "winslow-core";
import { selectSupportedApps } from "../../redux/features/connectedApps/connectedAppsSlice";
import { handleCopyText } from "../uiHelpers";

type SnippetSidebarResourceProps = {
  linkRecord: LinkRecord;
};

const TITLE_LENGTH = 60;

export const SnippetSidebarResource = ({
  linkRecord,
}: SnippetSidebarResourceProps) => {
  const storeUser = useSelector(selectUser);
  const supportedApps = useSelector(selectSupportedApps);

  const link: Link | null =
    linkRecord && linkRecord.links && linkRecord.links.length > 0
      ? linkRecord.links[0]
      : null;

  let appLogoPath = "";
  let appId = link ? link.appId : "";

  if (link && link.appId) {
    const logo = getAppLogoFromLinkRecord(
      linkRecord,
      supportedApps,
      "-activity.svg"
    );

    appLogoPath = getActivityLogoFilePathInMode(
      logo,
      storeUser?.theme as ("light-mode" | "dark-mode") | undefined
    );
  }

  const url = link ? link.url : "";

  if (linkRecord.favicon) {
    appLogoPath = linkRecord.favicon;
  }

  let title = ("" + (link && link.title)).substring(0, TITLE_LENGTH);
  title += title.length > TITLE_LENGTH - 1 ? "..." : "";

  return (
    <div
      className="snippet-sidebar-resource"
      onClick={() => window.open(url, "__new")}>
      <div className="snippet-sidebar-resource-logo">
        <img src={appLogoPath} alt="" />
      </div>
      <div className="snippet-sidebar-resource-name">{title}</div>
      <div
        className="snippet-sidebar-resource-icons"
        onClick={(e: any) => {
          e.stopPropagation();
          handleCopyText(url);
        }}>
        <img src={iconPath("copy.svg", storeUser)} alt="" />
      </div>
    </div>
  );
};
